export const getSecToMs = (seconds: number) => seconds * 1000;
